import { InviteTeamMeta, InviteTeamPayload } from 'types/store/InviteTeam';
import { createAsyncReducer } from 'utils/Redux';

import { inviteTeamActions } from '../actions';

export default createAsyncReducer<InviteTeamMeta, InviteTeamPayload>(inviteTeamActions);
